export const constants = {
  techpadDiagram : {
    requestHeaderKeyName : 'TechpadDiagramSecureKey',
    requestHeaderKeyValue : 'YyJSL4P6TPLN1topjcMNgSswy8dEecOw5EG9gPgdkjo4rPe9ZEodqUkul5DfmcOzq'
  }
}


// WEBPACK FOOTER //
// ./src/scripts/constants/authorizationConstants.js